import { useQuery } from "@tanstack/react-query"
import { getTransferOrderAttachment } from "customerAttachments/apis"
import { TransferAttachType } from "customerAttachments/types"

type useGetTransferAttachmentProps = {
  transferId: string
  attachType: TransferAttachType
}

const useGetTransferAttachment = ({ transferId, attachType }: useGetTransferAttachmentProps) => {
  const { data, isLoading, isSuccess } = useQuery({
    enabled: !!transferId && !!attachType,
    queryKey: ["transferAttach", transferId, attachType],
    queryFn: () => getTransferOrderAttachment({ transferId, attachType }),
    select: (data) => data?.Data,
  })
  return { data, isLoading, isSuccess }
}

export default useGetTransferAttachment
